import styled, { createGlobalStyle, css } from "styled-components";

export const GlobalStyle = createGlobalStyle`
@media print {
  @page {
    size: auto;
    margin: 0;
  }

  body,
  html {
    width: 100%;
    height: 100%;
    margin-top: 0%;
    display: block;
    margin-top: 0;
    max-height: 100vh;
    overflow: visible !important;
  }

  .no-print {
    display: none;
  }

  footer {
    display: none;
  }
}
`;

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 0px 10px;
`;

export const Content = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const MainContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ContentContainer = styled.div`
  position: fixed;
  width: 100%;
`;

export const MainBody = styled.main`
  flex: 1;
  overflow-y: auto;
  position: absolute;
  height: 100%;
  left: 270px;
  width: calc(100% - 270px);
  max-width: calc(100% - 270px);
`;

export const Header = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  background-color: #38527c;
  color: white;
  padding: 50px 60px 25px;
`;

export const Title = styled.h1`
  color: white;
  font-size: 30px;
  font-weight: 600;
  line-height: 1.2;
`;

export const SubTitle = styled.h2`
  color: white;
  font-size: 22px;
  font-weight: 400;
  line-height: 1.2;
  margin: 0;
  margin-bottom: 12px;
`;

export const Date = styled.p`
  color: #e0e6ea;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
`;

export const Logo = styled.img`
  position: absolute;
  width: 40px;
  height: 40px;
  right: 50px;
`;

export const CampaignInformation = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #ffffff;
  padding: 25px 60px 35px;
`;

export const Stellentitel = styled.div`
  color: #505050;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 6px;
`;

export const JobTitle = styled.div`
  color: #505050;
  font-size: 24px;
  font-weight: 400;
  margin: 5px 0;
`;

export const CampaignName = styled.div`
  color: #505050;
  font-size: 14px;
  margin-top: 2px;
  font-weight: 400;
`;

export const CampaignMetrics = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #505050;
  padding: 20px 60px;
`;

export const CampaignLocation = styled.div`
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 10px;
`;

export const Anzeigenlink = styled.div`
  color: #505050;
  display: flex;
  font-size: 16px;
  font-weight: 400;
`;

export const Link = styled.div`
  color: blue;
  margin-left: 5px;
`;

export const CreativeMetrics = styled.div`
  h2 {
    color: #4468b0;
    font-weight: 600;
    font-size: 24px;
    margin-top: 10px;
  }
`;

export const Channel = styled.div`
  page-break-inside: avoid;
  min-height: 160px;
  background-color: white;
  color: black;
  padding: 0 60px;

  &:last-of-type {
    margin-bottom: 30px;
  }

  &:first-child {
    h2 {
      margin-top: 20px;
    }
  }

  h2 {
    color: #4468b0;
    font-weight: 600;
    font-size: 24px;
    margin-top: 10px;
    margin-bottom: 8px;

    &.facebook {
      color: #4468b0;
    }

    &.instagram {
      color: #b831a7;
    }

    &.youtube {
      color: #ff0001;
    }

    &.spotify {
      color: #20d760;
    }

    &.linkedin {
      color: #0077b5;
    }

    &.tiktok {
      color: #0077b5;
    }

    &.ebay-kleinanzeigen {
      color: #86b817;
    }

    &.reddit {
      color: #085ff7;
    }

    &.pinterest {
      color: #e60323;
    }

    &.google-search {
      color: #085ff7;
    }

    &.indeed {
      color: #085ff7;
    }
  }
`;

export const ChannelMetric = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f1eaea;
  color: black;
  width: 100%;
  height: 100px;
  border-radius: 5px;
  justify-content: center;
  align-items: center;

  &:not(:last-child) {
    margin-right: 20px;
  }

  span {
    font-weight: 400;
    padding-bottom: 5px;

    &:first-child {
      font-size: 22px;
    }

    &:last-child {
      font-size: 16px;
    }
  }
`;

export const StatusBox = styled.li`
  list-style-type: none;
  background-color: #f1eaea;
  color: black;
  border-radius: 5px;
  width: 300px;
  padding: 20px 20px 1px;
  font-weight: 400;
  font-size: 16px;

  > div {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    margin-bottom: 20px;

    span:last-child {
      font-size: 24px;
    }
  }
`;

export const StatusBoxContent = styled.div`
  display: flex;
  margin-bottom: 15px;
`;

export const NoFacebookInstagramChannelTitle = styled.h2`
  color: #4468b0;
  font-weight: 600;
  font-size: 24px;
  margin-top: 10px;
  margin-bottom: 8px;
`;

export const NoFacebookInstagramChannel = styled.div`
  list-style-type: none;
  background-color: #f1eaea;
  color: black;
  border-radius: 5px;
  font-weight: 400;
  font-size: 16px;
  height: 100px;
  align-items: center;
  display: flex;
  text-align: center;
  justify-content: center;
  padding: 20px;
`;

export const CreativesWrapper = styled.div`
  padding: 0 60px;
`;

export const PrintMessageTitle = styled.div`
  color: ${({ theme }) => theme.colors.dataViz.printMessageColor};
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-left: 27px;
`;

export const PrintMessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  max-width: 1180px;
  margin-bottom: 30px;

  @media print {
    page-break-inside: avoid;
    break-inside: avoid;
    padding-top: 2rem;
  }
`;

export const PrintMessages = styled.div`
  display: flex;
  gap: 10px;
  & > :nth-child(n) {
    max-width: 500px;
    min-width: 320px;
    border-right: 1px solid #abb4f4;
    padding: 0px 27px;
  }

  & > :last-child {
    padding-left: 27px;
    border-right: none;
  }
`;

export const Group = styled.div`
  display: flex;
  flex-direction: ${({ direction }) => direction || "row"};
  gap: 10px;
  width: ${({ width }) => width || "100%"};

  > div {
    flex: 1;
  }
`;

export const chartStyling = css`
  border: none;
  min-width: 400px;
  height: 300px;
`;

export const funnelChartStyling = css`
  border: none;
  min-width: 800px;
`;

export const printStyling = css`
  flex: 1;
`;
